export const CourseActionTypes = {
    SET_COURSES: 'SET_COURSES'
}